const FileManagerActionType = {
  GET_DIRECTORIES: 'GET_DIRECTORIES',
  CHANGE_ALL_DIRECTORIES_LOADING_STATE: 'CHANGE_ALL_DIRECTORIES_LOADING_STATE',
  SAVE_DIRECTORIES: 'SAVE_DIRECTORIES',
  SAVE_BASE_DIRECTORIES: 'SAVE_BASE_DIRECTORIES',

  GET_FILE_TYPE_GROUPS: 'GET_FILE_TYPE_GROUPS',
  GET_FILE_TYPE_GROUPS_SUCCESS: 'GET_FILE_TYPE_GROUPS_SUCCESS',

  RENAME_PUBLIC_FILE: 'RENAME_PUBLIC_FILE',
  RENAME_PUBLIC_DIRECTORY: 'RENAME_PUBLIC_DIRECTORY',

  DELETE_PUBLIC_FILES: 'DELETE_PUBLIC_FILES',
  DELETE_PUBLIC_DIRECTORY: 'DELETE_PUBLIC_DIRECTORY',

  CHANGE_FILE_MANAGER_BRAND_ID: 'CHANGE_FILE_MANAGER_BRAND_ID',

  CHANGE_FILE_MANAGER_MODAL_VISIBILITY: 'CHANGE_FILE_MANAGER_MODAL_VISIBILITY',
  CHANGE_FILE_MANAGER_POPOVER_VISIBILITY: 'CHANGE_FILE_MANAGER_POPOVER_VISIBILITY',

  CHANGE_FILE_MANAGER_LOADING_STATE: 'CHANGE_FILE_MANAGER_LOADING_STATE',

  RESET_FILE_MANAGER_STATE: 'RESET_FILE_MANAGER_STATE',

  CREATE_DIRECTORY: 'CREATE_DIRECTORY',

  CHANGE_DIRECTORIES_ENDED_STATUS: 'CHANGE_DIRECTORIES_ENDED_STATUS',

  MOVE_PUBLIC_FILES: 'MOVE_PUBLIC_FILES',

  GET_FILES_BY_PATHS: 'GET_FILES_BY_PATHS',
  SAVE_FILES_BY_PATHS: 'SAVE_FILES_BY_PATHS',
  RESET_FILES_BY_PATHS: 'RESET_FILES_BY_PATHS',

};

export default FileManagerActionType;
